import type { FirestoreContainer } from './FirestoreContainer.js';

import { createContainer } from '@elara/core/di';

import { createClientFlightOptionModel } from '#models/FlightOptionModel.js';

/**
 * Client-side FlightOption container for dependency injection.
 * Provides the Firestore-backed FlightOption model for resolving flight options by id.
 */
export function createFlightOptionsContainer(firestore: FirestoreContainer) {
  const $flightOptions = createContainer('flightOptions').providedLazy('ClientFlightOption', () =>
    createClientFlightOptionModel(firestore),
  );
  return $flightOptions;
}

export type $FlightOptionsContainer = ReturnType<typeof createFlightOptionsContainer>;
export type FlightOptionsContainer = $FlightOptionsContainer['use'];
